export default __webpack_public_path__ + "images/a5df44c86e40f40ed7b561635e9a6f37.svg";